import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Carousel from 'react-bootstrap/Carousel';
import Mainservices from './mainservices';
import Separator from './separador';
import img1 from '../img/img1.JPG'; import img2 from '../img/img2.jpg';
import img3 from '../img/img3.jpg'; import img4 from '../img/img4.JPG';
import img5 from '../img/img5.jpg'; import img6 from '../img/img6.JPG';
import banner1 from '../img/Banner1.jpeg'; import banner2 from '../img/Banner2.jpeg';
import banner3 from '../img/Banner3.jpeg';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import React, { useState } from 'react';

import './main.css';



function Main() {
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showModal5, setShowModal5] = useState(false);
  const [showModal6, setShowModal6] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  const handleClose3 = () => setShowModal3(false);
  const handleShow3 = () => setShowModal3(true);

  const handleClose4 = () => setShowModal4(false);
  const handleShow4 = () => setShowModal4(true);

  const handleClose5 = () => setShowModal5(false);
  const handleShow5 = () => setShowModal5(true);

  const handleClose6 = () => setShowModal6(false);
  const handleShow6 = () => setShowModal6(true);

  return (
    <div className='blackContainer'>

      {/*aqui empieza el carousel*/}
      <div className='container-carousel'>
        <Carousel data-bs-theme="white">
          <Carousel.Item className='carousel-item'>
            <img
              className="d-block w-100"
              src={banner1}
              alt="First slide"
            />
            <Carousel.Caption>
              <h5></h5>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="d-block w-100"
              src={banner2}
              alt="Second slide"
            />
            <Carousel.Caption>
              <h5></h5>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={banner3}
              alt="Third slide"
            />
            <Carousel.Caption>
              <h5></h5>
              <p></p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>
      {/*aqui termina el carousel*/}

      {/*aqui comineza las tarjetas proyecto*/}
      <Container>
        <br />
        <div className='Center'>
          <h1 id="Projects">Our projects</h1>
        </div>
        <br />
        <Row xs={1} md={3} className="g-4">
          {Array.from({ length: 1 }).map((_, idx) => (
            <Col key={idx}>
              <a className='linkp' onClick={handleShow}>
                <Card className="cardP" >
                  <Card.Img variant="top" id="Project1" src={img1} />
                  <Card.Body>
                    <Card.Title className="Center">Renovation</Card.Title>
                    <Card.Text className="Center">
                      Renovation of the facades
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>
            </Col>
          ))}

          <Modal show={showModal} onHide={handleClose}>
            <Modal.Header className='bodymid'>
              <Modal.Title className='title' >Modal Title</Modal.Title>
            </Modal.Header>
            <Modal.Body className='bodymid'>
              <div className='container-projects'>
                <img src={img1} />
                <div className='project-description'>
                  <h2 className='titulo-projects'>Renovation </h2>
                  The renovation of the facades of the "Vista Hermosa" residential complex was a key initiative to revitalize the appearance and functionality of the buildings. The primary goal of this project was to modernize the complex's image, improve the durability of the structures, and enhance the visual appeal of the residential environment.<br></br><br></br>

                  <h1>Renovation Details:</h1>
                  <h1>Initial Evaluation and Planning:</h1><br></br>
                  Technical Inspection: A thorough assessment of the current conditions of the facades was conducted, identifying areas with structural damage, coating wear, and moisture problems.<br></br><br></br>
                  Architectural Design: Architects designed new facades that combined modern elements with the original aesthetics of the residential complex. Several proposals were presented to the residents to ensure their satisfaction and approval.
                </div>

              </div>
            </Modal.Body>
            <Modal.Footer className='bodymid'> 
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {Array.from({ length: 1 }).map((_, idx) => (
            <Col key={idx}>
              <a className='linkp' onClick={handleShow2}>
                <Card className="cardP">
                  <Card.Img variant="top" id="trabajos" src={img5} />
                  <Card.Body>
                    <Card.Title className="Center">Custom design</Card.Title>
                    <Card.Text className="Center">
                      The remodeling of the stairs
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>
            </Col>
          ))}

          <Modal show={showModal2} onHide={handleClose2}>
            <Modal.Header className='bodymid'>
              <Modal.Title className='title'>Modal Title</Modal.Title>
            </Modal.Header>
            <Modal.Body className='bodymid'>
              <div className='container-projects'>
                <img src={img5} />
                <div className='project-description'>
                  <h2 className='titulo-projects'>Renovation </h2>
                  The construction of the main entrance door for the residence "Casa de los Rodríguez" was carried out with the purpose of enhancing the security, functionality, and aesthetics of the home's entrance. This project involved installing a new door that not only provided protection and privacy but also complemented the architectural design and style of the house.
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className='bodymid'>
              <Button variant="secondary" onClick={handleClose2}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {Array.from({ length: 1 }).map((_, idx) => (
            <Col key={idx}>
              <a className='linkp' onClick={handleShow3}>
                <Card className="cardP">
                  <Card.Img variant="top" id="trabajos" src={img3} />
                  <Card.Body>
                    <Card.Title className="Center">Custom fencing</Card.Title>
                    <Card.Text className="Center">
                      The renovation of the staircase ornaments
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>
            </Col>
          ))}

          <Modal show={showModal3} onHide={handleClose3}>
            <Modal.Header className='bodymid'>
              <Modal.Title>Modal Title</Modal.Title>
            </Modal.Header>
            <Modal.Body className='bodymid'>
              <div className='container-projects'>
                <img src={img3} />
                <div className='project-description'>
                  <h2 className='titulo-projects'>Renovation </h2>
                  The renovation of the staircase ornaments in the "Casa de los Pérez" was undertaken with the goal of revitalizing and modernizing the decorative details of this central area of the home. This project involved updating ornamental elements, including railings, handrails, and moldings, with a focus on improving the aesthetics, functionality, and safety of the staircase.<br></br><br></br>

                  <h1>Renovation Details:</h1>
                  <h1>Initial Evaluation and Planning:</h1><br></br>
                  Technical Inspection: A thorough evaluation of the existing ornaments was conducted to identify wear and tear, damage, and potential safety hazards. Specifically, the railings, handrails, and decorative moldings were assessed.<br></br><br></br>
                  Design and Planning: In collaboration with the homeowners, several designs were developed that combined traditional elements with modern touches. Different material and finish options were presented to ensure the homeowners' satisfaction and harmony with the rest of the home.
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className='bodymid'>
              <Button variant="secondary" onClick={handleClose3}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

        </Row>

        <br />

        <Row xs={1} md={3} className="g-4">
          {Array.from({ length: 1 }).map((_, idx) => (
            <Col key={idx}>
              <a className='linkp' onClick={handleShow4}>
                <Card className="cardP">
                  <Card.Img variant="top" id="trabajos" src={img4} />
                  <Card.Body>
                    <Card.Title className="Center">Construction</Card.Title>
                    <Card.Text className="Center">
                      The construction of the staircase
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>

            </Col>
          ))}

          <Modal show={showModal4} onHide={handleClose4}>
            <Modal.Header className='bodymid'>
              <Modal.Title >Modal Title</Modal.Title>
            </Modal.Header>
            <Modal.Body className='bodymid'>
              <div className='container-projects'>
                <img src={img4} />
                <div className='project-description'>
                  <h2 className='titulo-projects'>Renovation </h2>
                  The construction of the staircase for the entrance of "Café La Plaza" was carried out with the aim of improving access and the aesthetic appeal of the establishment. This project involved the creation of new stairs that not only provided safe and functional access.
                  <h1>Renovation Details:</h1>
                  <h1>Initial Evaluation and Planning:</h1><br></br>
                  Technical Inspection: A comprehensive assessment of the existing ornaments was conducted to identify wear, damage, and potential safety risks. Specifically, the railings, handrails, and decorative moldings were evaluated.<br></br><br></br>
                  Design and Planning: In collaboration with the owners, several designs were developed that combined traditional elements with modern touches. Different material and finish options were presented to ensure the satisfaction of the owners and harmony with the rest of the establishment.
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className='bodymid'>
              <Button variant="secondary" onClick={handleClose4}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {Array.from({ length: 1 }).map((_, idx) => (
            <Col key={idx}>
              <a className='linkp' onClick={handleShow5}>
                <Card className="cardP">
                  <Card.Img variant="top" id="trabajosFix" src={img2} />
                  <Card.Body>
                    <Card.Title className="Center">Decorative gates</Card.Title>
                    <Card.Text className="Center">
                      The construction of the main entrance door
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>
            </Col>
          ))}

          <Modal show={showModal5} onHide={handleClose5}>
            <Modal.Header className='bodymid'>
              <Modal.Title>Modal Title</Modal.Title>
            </Modal.Header>
            <Modal.Body className='bodymid'>
              <div className='container-projects'>
                <img src={img2} />
                <div className='project-description'>
                  <h2 className='titulo-projects'>Renovation </h2> <br></br>
                  The remodeling of the stairs at "Casa de los Pérez" was carried out with the aim of enhancing both the functionality and aesthetics of this central area of the home. The project involved a complete renovation that encompassed everything from the structure and materials to the finishes and decoration, with a focus on safety, durability, and modern design. <br></br>
                  <h1>Renovation Details:</h1><br></br>
                  <h1>Initial Evaluation and Planning:</h1><br></br>
                  Technical Inspection: A detailed inspection of the existing stairs was conducted to identify structural issues, wear and tear, and areas needing updates. This included the evaluation of the railing, steps, and supports.<br></br><br></br>
                  Design and Planning: In collaboration with the homeowners, a design was developed that combined functionality and aesthetics. Several design and material options were presented, taking into account style preferences and the available budget.
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className='bodymid'>
              <Button className='buttom' variant="secondary" onClick={handleClose5}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {Array.from({ length: 1 }).map((_, idx) => (
            <Col key={idx}>
              <a className='linkp' onClick={handleShow6}>
                <Card className="cardP">
                  <Card.Img variant="top" id="trabajos" src={img6} />
                  <Card.Body>
                    <Card.Title className="Center">Railing</Card.Title>
                    <Card.Text className="Center">
                      The construction of an internal staircase
                    </Card.Text>
                  </Card.Body>
                </Card>
              </a>
            </Col>
          ))}

          <Modal show={showModal6} onHide={handleClose6}>
            <Modal.Header className='bodymid'>
              <Modal.Title>Modal Title</Modal.Title>
            </Modal.Header>
            <Modal.Body className='bodymid'>
              <div className='container-projects'>
                <img src={img6} />
                <div className='project-description'>
                  <h2 className='titulo-projects'>Renovation </h2>
                  The construction of an internal staircase for the family residence "Casa de los Gómez" was undertaken to enhance accessibility and functionality within the home, while adding an aesthetic and structural element that would improve the distribution of interior space. This project involved installing a new staircase to facilitate safe and comfortable movement between different levels of the house.<br></br><br></br>

                  <h1>Renovation Details:</h1>
                  <h1>Initial Evaluation and Planning:</h1><br></br>
                  Space Inspection: A detailed evaluation of the designated area for the staircase was conducted, taking into account floor-to-floor height, existing architectural design, and safety requirements.<br></br><br></br>
                  Design and Specifications: In collaboration with the homeowners, a customized design was developed to meet both functional and aesthetic needs of the home. Material options such as wood, concrete, or metal were discussed, alongside considerations for style and integration with interior decor.

                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className='bodymid'>
              <Button variant="secondary" onClick={handleClose6}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

        </Row>
      </Container>

      {/*aqui termina las tarjetas proyecto*/}

      <div className='whiteContainer'>
        <Separator />
        <Mainservices />
      </div>

    </div>

  );
}

export default Main;